// extracted by mini-css-extract-plugin
export default {"modalWrapper":"GjJ9pLpgWSWc9HKkmD5X"};